// Coherent fictional dataset for WeKIT Education Intelligence™ demo.
// Every dashboard should reference this so the demo feels authentic.

export const school = {
  name: "Greenwood International School",
  principal: "Dr. Anaya Menon",
  academicYear: "2026–27",
  location: "Bengaluru, India",
  students: 1248,
  teachers: 56,
  counsellors: 3,
  parents: 1102,
  seatsLicensed: 1400,
};

export const grades = [
  { grade: "8",  students: 268, hdi: 79, cci: 71, fri: 66, completion: 92 },
  { grade: "9",  students: 254, hdi: 82, cci: 74, fri: 70, completion: 89 },
  { grade: "10", students: 251, hdi: 84, cci: 78, fri: 73, completion: 94 },
  { grade: "11", students: 239, hdi: 86, cci: 82, fri: 76, completion: 91 },
  { grade: "12", students: 236, hdi: 88, cci: 85, fri: 80, completion: 96 },
];

// Modules per grade — completion %
export const moduleCompletion = [
  { module: "WALS™ Life Skills",          "8": 94, "9": 91, "10": 96, "11": 93, "12": 97 },
  { module: "WAFLE™ Financial Literacy",  "8": 62, "9": 68, "10": 72, "11": 78, "12": 84 },
  { module: "WAFFS™ Future Skills",       "8": 71, "9": 76, "10": 80, "11": 83, "12": 88 },
  { module: "WCC360 Assessment",          "8": 92, "9": 89, "10": 94, "11": 91, "12": 96 },
];

export const kpis = {
  activeStudents: 1187,
  assessmentCompletion: 92,
  humanDevelopmentIndex: 84,
  futureReadinessIndex: 73,
  careerClarityIndex: 78,
  parentEngagement: 68,
};

// Human Development heatmap: dimensions × grades
export const hdiHeatmap = {
  dimensions: ["Cognitive", "Social", "Emotional", "Career", "Creativity", "Leadership", "Financial", "AI Literacy"],
  grades: ["8", "9", "10", "11", "12"],
  values: [
    [78, 80, 83, 85, 88],
    [82, 84, 86, 88, 89],
    [74, 77, 80, 83, 85],
    [68, 72, 76, 82, 86],
    [79, 81, 82, 82, 83],
    [72, 76, 80, 84, 87],
    [58, 63, 68, 74, 82],
    [65, 69, 72, 76, 81],
  ],
};

export const careerInterests = [
  { cluster: "AI & Data Science",      value: 22 },
  { cluster: "Biomedical & Healthcare", value: 17 },
  { cluster: "Design & Product",        value: 14 },
  { cluster: "Business & Finance",      value: 13 },
  { cluster: "Engineering",             value: 12 },
  { cluster: "Climate & Sustainability",value: 9 },
  { cluster: "Media & Storytelling",    value: 7 },
  { cluster: "Public Policy",           value: 6 },
];

export const futureSkills = [
  { skill: "AI Literacy",       score: 71, delta: +6 },
  { skill: "Financial Literacy", score: 68, delta: +4 },
  { skill: "Communication",     score: 83, delta: +2 },
  { skill: "Collaboration",     score: 86, delta: +3 },
  { skill: "Creativity",        score: 79, delta: +1 },
  { skill: "Problem Solving",   score: 76, delta: +2 },
];

export const studios = [
  { name: "WALS™",  full: "Life Skills",         adoption: 94, modules: 12, active: 1112 },
  { name: "WAFLE™", full: "Financial Literacy",  adoption: 74, modules: 8,  active: 878 },
  { name: "WAFFS™", full: "Future Skills",       adoption: 81, modules: 10, active: 962 },
];

export const aiInsightsPrincipal = [
  {
    tone: "opportunity" as const,
    title: "Creativity is peaking in Grade 9",
    body: "Grade 9 students show exceptional creativity scores (81/100), 6 points above the school average. Consider introducing the Innovation Challenge earlier this term to compound this momentum.",
    actions: [
      { label: "Filter to Grade 9", to: "/schools?grade=9" },
      { label: "Open Learning Studios", to: "/schools/studios?grade=9" },
    ],
  },
  {
    tone: "watch" as const,
    title: "Financial Literacy lag in lower grades",
    body: "Grades 8–9 sit at 58–63 on Financial Literacy, well below the Human Development average. A short WAFLE™ intensive over the next 6 weeks would close most of the gap before Q3 assessments.",
    actions: [
      { label: "See WAFLE™ studio", to: "/schools/studios" },
      { label: "Filter to Grade 8", to: "/schools?grade=8" },
    ],
  },
  {
    tone: "positive" as const,
    title: "Parent engagement up 18% this month",
    body: "1,102 parents (68%) engaged with their child's reports this month, up 18% from October. Weekly reflection nudges correlate strongly with improved Career Clarity outcomes.",
    actions: [
      { label: "Open Parent view", to: "/schools/parent" },
    ],
  },
  {
    tone: "positive" as const,
    title: "Reflections predict clarity",
    body: "Students completing weekly reflections show a Career Clarity Index that is 14 points higher than non-reflectors. Reflection consistency remains the single strongest predictor of clarity gains.",
    actions: [
      { label: "Open a student profile", to: "/schools/student" },
    ],
  },
];
